module.exports = __webpack_public_path__ + "static/img/8.96b28c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/8.jpg
// module id = cIzi
// module chunks = 5